import { StrictMode } from "react";
import { createRoot, Root } from "react-dom/client";

import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isToday from "dayjs/plugin/isToday";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isToday);
dayjs.extend(utc);
dayjs.extend(timezone);

import { routeTree } from "./routeTree.gen";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";

import "./index.css";
const router = createRouter({ routeTree, basepath: "" });
const queryClient = new QueryClient();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Store the React root globally for clean unmounting
let root: Root | null = null;

// Expose mount/unmount functions globally
(window as any).mountPpsApp = (containerId = "pps") => {
  const container = document.getElementById(containerId);
  if (container && !root) {
    root = createRoot(container);
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </StrictMode>,
    );
  }
};

(window as any).unmountPpsApp = () => {
  if (root) {
    root.unmount();
    root = null;
  }
};

// For dev: if running standalone, auto-mount
if (import.meta.env.DEV || import.meta.env.VITE_STANDALONE_MODE) {
  const container = document.getElementById("pps");
  if (container) {
    (window as any).mountPpsApp("pps");
  }
}
